import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserPlusIcon, UserCheckIcon, Loader2Icon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { useAssociateStatus } from './AssociateStatusContext';
type AssociateButtonProps = {
  idleLabel: string;
  onRequest?: () => void;
};
const swap = {
  initial: {
    opacity: 0,
    scale: 0.97
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0.97
  },
  transition: {
    duration: 0.28,
    ease: [0.22, 1, 0.36, 1] as const
  }
};
export function AssociateButton({
  idleLabel,
  onRequest
}: AssociateButtonProps) {
  const {
    t
  } = useLanguage();
  const {
    status,
    request
  } = useAssociateStatus();
  const handleRequestClick = () => {
    request();
    if (onRequest) onRequest();
  };
  return <div className="relative w-full h-[77px]" data-id="element-14">
      <AnimatePresence mode="wait" initial={false} data-id="element-15">
        {status === 'idle' ? <motion.button key="idle" {...swap} whileTap={{
        scale: 0.97
      }} onClick={handleRequestClick} className="absolute inset-0 overflow-hidden w-full flex items-center justify-center gap-2 rounded-2xl pl-6 pr-20 font-semibold text-base bg-white text-blue-600 border-2 border-blue-100 hover:border-blue-200 hover:bg-slate-50 transition-colors" data-id="element-16">
            <UserPlusIcon size={20} className="text-blue-600" data-id="element-17" />
            {idleLabel}
            <img src="https://cdn.magicpatterns.com/uploads/eAWfw77qezj27KdafqpQRB/ChatGPT_Image_Jun_3,_2026,_10_49_00_PM.png" alt="Mike, store associate" className="absolute right-2 bottom-0 h-[68px] w-16 object-cover object-top pointer-events-none" data-id="element-18" />
          </motion.button> : status === 'requesting' ? <motion.div key="requesting" {...swap} className="absolute inset-0 w-full flex items-center justify-center gap-2.5 rounded-2xl px-6 font-semibold text-base bg-white text-blue-600 border-2 border-blue-100" data-id="element-19">
            <motion.span animate={{
          rotate: 360
        }} transition={{
          repeat: Infinity,
          duration: 0.9,
          ease: 'linear'
        }} className="inline-flex" data-id="element-20">
              <Loader2Icon size={22} className="text-blue-600" data-id="element-21" />
            </motion.span>
            {t('associate.requesting')}
          </motion.div> : <motion.div key="confirmed" {...swap} className="absolute inset-0 w-full flex flex-col justify-center gap-1.5 rounded-2xl py-3 px-6 font-semibold bg-green-500 text-white border-2 border-green-600" data-id="element-22">
            <div className="flex items-center gap-2 text-[13px] leading-tight" data-id="element-23">
              <UserCheckIcon size={16} className="shrink-0" data-id="element-24" />
              <span data-id="element-25">{t('associate.onTheWay')}</span>
            </div>
            <div className="h-2 w-full rounded-full bg-white/30 overflow-hidden" data-id="element-26">
              <motion.div initial={{
            width: '0%'
          }} animate={{
            width: ['10%', '92%']
          }} transition={{
            duration: 90,
            ease: 'linear'
          }} className="h-full rounded-full bg-white" data-id="element-27" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}